export default {
    amount: "Amount",
    price: "Price",
    apply_monthly_change_now: "Apply difference this month",
    update_button: "Update",
    description: "Description",
    total: "Total",
    cost_per_tool: "Cost per Tool",
    see_all_costs: "See all ({count})",
    credit: "Credit",
    credits: "Credits",
    no_cost_available:
        "No cost available as this establishment does not yet have a credit plan.",
    add_plan: "Add a Plan",
    next_recharge: "Next recharge:",
    credits_in: "credits in",
    recharge_history: "Recharge history",
    balance: "Balance",
    month_year: "Month / Year",
    expired: "Expired",
    available: "Available",
    expiration: "Expiration",
    monthly_plan: "Monthly Plan",
    monthly_adjustment: "Monthly Plan Adjustment",
    extra_package: "Extra Package",
    not_informed: "Not informed",
    monthly_plan_updated: "Monthly plan updated",
    page_title: "Credits",
    load_error: "An error occurred while loading your account's financial data. Please try reloading the page.",
    usage_history_error: "Could not load the usage history at this time.",
    not_enough_data: "Not enough data for the period.",
    data_load_error: "An error occurred while loading data. Please try again.",
    no_active_package: "No active credit package at the moment.",
    current_balance: "Current balance",
    credit_options: "Credit options",
    adjust_monthly_package: "Adjust Monthly Package",
    no_data_for_period: "No data for the period",
    consumption_by_action: "Consumption by action:",
    action: "Action",
    no_consumption_for_period: "No consumption registered in the period.",
    usage_history_title: "Usage history:",
    detailed_usage_statement: "Detailed Usage Statement",
    total_records_found: "Total records found in the period: {count}",
    automation_campaign: "Automation/Campaign",
    credits_consumed: "Consumed Credits",
    no_records_found: "No records found in the period.",
    next: "Next",
    previous: "Previous",
    no_changes_detected: "No changes detected",
    price_difference_charged: "Price difference charged: {amount}",
    generating_invoice: "Invoice generated! Opening WhatsApp...",
    error_processing_invoice: "Error processing invoice request.",
    server_communication_error: "Server communication failure.",
    whatsapp_msg_intro: "Hello! I have a credit request:",
    whatsapp_msg_establishment: "Establishment: {name}",
    whatsapp_msg_requester: "Requester: {name}",
    whatsapp_msg_details_adjust: "Request: Adjust Monthly Package to {credits} credits",
    whatsapp_msg_details_extra: "Request: Extra Package of {credits} credits",
    contract_button: "Contract",
    inform_credits_amount: "Please inform the desired amount of credits",
    credits_added_success: "Credits added successfully!",
    error_processing_request: "Error processing request.",
    credits_statement: "Statement",
    loading_data: "Loading data...",
    automation: "Automation",
    campaign: "Campaign",
    page_x_of_y: "Page {current} of {total}",
    close: "Close",
    manage_credits: "Manage credits",
    view_recharge_history: "View recharge history",
    consumption_estimated_end_month: "Estimated consumption until the end of the month: {amount} credits",
    no_credits_available: "You have no more credits available",
    expires_in: "Expires in",
    next_packages_available: "Next available packages",
    view_full_history: "View full history",
    group_daily: "Daily",
    group_weekly: "Weekly",
    group_monthly: "Monthly",
    group_quarterly: "Quarterly",
    period_too_long_daily: "Period too long for daily view",
    period_too_long_weekly: "Period too long for weekly view",
    period_too_short_weekly: "Select at least 2 weeks for the weekly view",
    period_too_short_monthly: "Select at least 2 months for the monthly view",
    period_too_short_quarterly: "Select at least 6 months for the quarterly view",
    tooltip_others: "Others ({count} automations)",
    daily_average: "Daily average: {amount} credits",
    consumption_by_branch: "Consumption by branch:",
    consumption_by_category: "Consumption by category:",
    no_automation_found: "No automation or campaign found in the period.",
    action_type_manual: "Manual Adjustment",
    action_type_other: "Others",
    download_csv: "Download CSV",
    date_time: "Date/Time",
    credits_consumption: "Credits Consumption",
    expires_at_small: "expires",
    load_statement_error: "Error loading statement data.",
    prepare_csv_error: "Error preparing CSV export.",
    no_branch: "No branch",
    other: "Other",
    // Filter labels
    filter_by_date: "Filter by date",
    action_type_filter: "Action type",
    all_actions: "All actions",
    automations_filter: "Automations",
    campaigns_filter: "Campaigns",
    in_automations: "In automations:",
    in_campaigns: "In campaigns:",
    total_consumed: "Total credits consumed:",
    status_filter: "Status",
    active: "Active",
    inactive: "Inactive",
    segments: "Segments",
    // Package labels
    consumed: "consumed",
    used: "used",
    credit_package: "Credit package",
    monthly_package_label: "Monthly Package",
    single_package_label: "Single Package",
    monthly_partial_label: "Monthly Adjustment",
    // Notifications
    monthly_plan_updated: "Plan updated",
    monthly_plan_update_error: "Error updating plan",
    balance_load_error: "Error loading balance data. Please reload the page.",
    // Misc
    date: "Date",
    unknown: "Unknown",
    expand_chart: "Expand chart",
    category: "Category",
    trigger: "Trigger",
    action_type_whatsapp: "WhatsApp",
    action_type_whatsapp_api: "WhatsApp (API)",
    action_type_sms: "SMS",
    action_type_rcs: "RCS",
    action_type_email: "E-mail",
    action_type_ai: "AI",
    action_type_task: "Task",
    action_type_task_ai: "Task with AI",
    action_type_webhook: "WebHook",
    action_type_ai_basic: "Basic AI",
    action_type_ai_advanced: "Advanced AI",
    action_type_ai_gpt5: "Advanced AI (GPT-5)",
    action_type_ai_selection: "AI Selection",
    action_type_smart_insertion: "Smart Insertion",
    action_type_plugin: "Plugin Action",
    action_type_automation: "Automation",
    trigger_birthday: "Birthday",
    trigger_specific_date: "Specific Date",
    trigger_registration: "Registration",
    trigger_purchase: "Purchase",
    trigger_points: "Points Accumulated",
    trigger_inactivity: "Inactivity",
    view_full_statement: "View full statement",
    back_to_credits: "Back to Credits",
    credit_statement_title: "Credit Statement",
    credit_statement_subtitle: "Check your credits in detail",
    load_periods_error: "An error occurred while loading available periods. Please try reloading the page.",
    no_statement_available: "No statement available at the moment.",
    period_colon: "Period:",
    select_month_placeholder: "Select the desired month...",
    usage_details: "Usage Details",
    consumed_value: "Consumed Value",
    linked_client_id: "Linked Client ID",
    credit_type: "Credit Type",
    execution_id: "Execution ID",
    no_transactions_for_month: "No transactions found for {month}."
};
